import { useRouteLoaderData } from "~/hooks/useRouteLoaderData"

/**
 * Return context specific to the cache viewer.
 */
export function useViewerContext() {
  const { viewerContext } = useRouteLoaderData("routes/$site")
  return viewerContext
}
